import AppPageView from "./AppPageView";

import "./AppPageView.scss";

export { AppPageView };
